import { gql, useQuery } from "@apollo/client";

const GET_SALES = gql`
  query GetSales(
    $region: ID
    $district: ID
    $tariffClass: ID
    $serviceClass: ServiceClass
    $month: PositiveInt!
    $year: PositiveInt!
    $page: Int
    $pageSize: Int
    $search: String
    $searchFields: [String!]
    $sort: String
  ) {
    rows: getSales(
      region: $region
      district: $district
      tariffClass: $tariffClass
      serviceClass: $serviceClass
      month: $month
      year: $year
      page: $page
      pageSize: $pageSize
      search: $search
      searchFields: $searchFields
      sort: $sort
    ) {
      _id
      billType
      servicePointCode
      servicePointStatus
      tariffClassCode
      tariffClassName
      serviceClass
      geoCode
      accountCode
      meterCode
      meterModelType
      regionCode
      regionName
      districtCode
      districtName
      soeName
      mdaName
      ministryName
      isSensitive
      customerName

      billConsumptionValue
      billConsumptionApparentValue
      billConsumptionMaxDemandValue
      billConsumptionExportValue
      outstandingAmount
      lifeLineAmount
      firstThresholdAmount
      secondThresholdAmount
      energyCharge
      serviceCharge
      energyPlusServiceCharge
      powerFactorSurcharge
      vatCharge
      nhilCharge
      getfundCharge
      streetLightCharge
      nationalElectrificationCharge
      billAmount
      paymentsAmount
      adjustmentAmount
      amountDue
      debtAmount
      billAvgConsumptionValue
      billConsumptionType
      lastPaymentAmount
      lastPaymentDate

      month
      year
      createdAt
      updatedAt
    }
    count: getSalesCount(
      region: $region
      district: $district
      tariffClass: $tariffClass
      serviceClass: $serviceClass
      month: $month
      year: $year
      search: $search
      searchFields: $searchFields
    )
  }
`;

export const useSales = (variables: any) => {
  const { data, ...rest } = useQuery(GET_SALES, {
    variables,
    notifyOnNetworkStatusChange: true,
  });
  const rows = data?.rows || [];
  const count = data?.count || 0;
  return { rows, count, ...rest };
};
